import React from 'react';

import { useAccountAllocation } from '@/cip/api/allocation';
import { BaseCard } from '@/components/BaseCard';
import { useRequiredParams } from 'utils';
import { AccountNavCash } from 'views/account/AccountNavCash';
import {
    CashAllocationTable,
    ConvictionAllocationTable,
    GrowthAllocationTable,
    SecuredAllocationTable,
} from 'views/account/AllocationTables';

export const AccountAllocationsTab = () => {
    const { accountGUID } = useRequiredParams(['accountGUID']);
    const { data: allocations, isLoading } = useAccountAllocation(accountGUID);

    const hasCashAllocations = isLoading || (allocations?.cashAllocation && allocations.cashAllocation.length > 0);
    const hasSecuredAllocations =
        isLoading || (allocations?.securedAllocation && allocations.securedAllocation.length > 0);
    const hasConvictionAllocations =
        isLoading || (allocations?.convictionAllocation && allocations.convictionAllocation.length > 0);
    const hasGrowthAllocations =
        isLoading || (allocations?.growthAllocation && allocations.growthAllocation.length > 0);

    const hasAnyAllocations =
        hasCashAllocations || hasSecuredAllocations || hasConvictionAllocations || hasGrowthAllocations;

    return (
        <div className="relative space-y-4">
            <AccountNavCash accountGUID={accountGUID} className="pt-4 pb-2 pl-4" />
            {!isLoading && !hasAnyAllocations && (
                <div className="flex items-center justify-center py-12">
                    <p className="text-muted-foreground">No allocations found for this account</p>
                </div>
            )}
            {hasCashAllocations && (
                <BaseCard className="mt-2 w-4xl" headerClassName="pt-3 pb-3" title="Cash Allocations">
                    <CashAllocationTable
                        allocations={allocations?.cashAllocation}
                        isLoading={isLoading}
                    ></CashAllocationTable>
                </BaseCard>
            )}
            {hasSecuredAllocations && (
                <BaseCard className="mt-2" headerClassName="pt-3 pb-3" title="Secured Allocations">
                    <SecuredAllocationTable
                        allocations={allocations?.securedAllocation}
                        isLoading={isLoading}
                    ></SecuredAllocationTable>
                </BaseCard>
            )}
            {hasConvictionAllocations && (
                <BaseCard className="mt-2" headerClassName="pt-3 pb-3" title="Conviction Allocations">
                    <ConvictionAllocationTable
                        allocations={allocations?.convictionAllocation}
                        isLoading={isLoading}
                    ></ConvictionAllocationTable>
                </BaseCard>
            )}
            {hasGrowthAllocations && (
                <BaseCard className="mt-2 w-fit max-w-full" headerClassName="pt-3 pb-3" title="Growth Allocations">
                    <GrowthAllocationTable
                        allocations={allocations?.growthAllocation}
                        accountConstraint={allocations?.accountConstraint}
                        isLoading={isLoading}
                    ></GrowthAllocationTable>
                </BaseCard>
            )}
        </div>
    );
};
